export default "__VITE_ASSET__Wv7ckYxK__"